import { ApolloClient, InMemoryCache } from '@apollo/client';

export const makeApolloClient = (token: string | null, baseUrl?: string) =>
  new ApolloClient({
    uri: `${baseUrl || process.env.NEXT_PUBLIC_API_URL}/rgql`,
    headers: {
      authorization: token ? `Bearer ${token}` : '',
    },
    cache: new InMemoryCache({
      typePolicies: {
        Query: {
          fields: {
            getPhonicsLessonGroup: {
              read(_, { args, toReference }) {
                return args?.id
                  ? toReference({
                      __typename: 'PhonicsLessonGroup',
                      id: args.id,
                    })
                  : null;
              },
            },
            getPhonicsLesson: {
              read(_, { args, toReference }) {
                return args?.id
                  ? toReference({
                      __typename: 'PhonicsLesson',
                      id: args.id,
                    })
                  : null;
              },
            },
            getPhonicsLessons: {
              keyArgs: false,
              merge(existing = [], incoming) {
                return [...existing, ...incoming];
              },
            },
          },
        },
      },
    }),
  });
